import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-EFFGNXG7KX';

const initializeGoogleAnalytics = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

const trackPageView = (url) => {
  ReactGA.send({ hitType: 'pageview', page: url });
};

const trackCustomEvent = (event) => {
  // event: { category, action, label?, value? }
  ReactGA.event(event);
};

export { initializeGoogleAnalytics, trackPageView, trackCustomEvent };
